
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faDownload, faUpload, faComment, faList, faClock, faStopwatch, faPen, faCheckSquare, faHeartbeat, } from "@fortawesome/free-solid-svg-icons";

const Task = () =>{
    return(
        <div>
            <div className="card mb-3">
                <div className="card-block mb-3">
                    <ul className="nav nav-pills" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="pill" href="#task_2">Task 
                                <label class="label-sm label-info m-l-5">0</label>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="pill" href="#action">Action
                            <label class="label-sm label-danger m-l-5 text-white">0</label>
                            <label class="label-sm label-success m-l-10 text-white">10</label>
                        </a>
                        </li>
                    </ul>
                    <div className="card-header-right">
                        <div className="d-block">
                            <div className="d-flex gap-10">
                                <div className="text-center border-right pe-2">
                                    <FontAwesomeIcon icon={faList} className="text-primary" />
                                    <span className="d-block">20</span>
                                    <span className="d-block text-primary f-14 fw-semibold">Total Task</span>
                                </div>
                                <div className="text-center border-right pe-2">
                                    <FontAwesomeIcon icon={faClock} className="text-secondary" />
                                    <span className="d-block">20</span>
                                    <span className="d-block text-secondary f-14 fw-semibold">Yet To Start</span>
                                </div>
                                <div className="text-center border-right pe-2">
                                    <FontAwesomeIcon icon={faStopwatch} className="text-info" />
                                    <span className="d-block">20</span>
                                    <span className="d-block text-info f-14 fw-semibold">In Progress</span>
                                </div>
                                <div className="text-center border-right pe-2">
                                    <FontAwesomeIcon icon={faPen} className="text-warning" />
                                    <span className="d-block">20</span>
                                    <span className="d-block text-warning f-14 fw-semibold">Review Pending</span>
                                </div>
                                <div className="text-center border-right pe-2">
                                    <FontAwesomeIcon icon={faCheckSquare} className="text-success" />
                                    <span className="d-block">20</span>
                                    <span className="d-block text-success f-14 fw-semibold">Approved</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3">
                <div className="card-block">
                    <div className="tab-content">
                        <div id="task_2" class="tab-pane active">
                            <ul className="nav nav-pills" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="pill" href="#yet_to_start">Yet to Start 
                                        <label class="label-sm label-info m-l-5">0</label>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="pill" href="#inprogress">In-Progress
                                        <label class="label-sm label-danger m-l-5 text-white">0</label>
                                        <label class="label-sm label-success m-l-10 text-white">10</label>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="pill" href="#approved">Approved
                                        <label class="label-sm label-danger m-l-5 text-white">0</label>
                                        <label class="label-sm label-success m-l-10 text-white">10</label>
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content mt-4">
                                <div id="yet_to_start" class="tab-pane active">
                                    Yet To Start
                                </div>
                                <div id="inprogress" class="tab-pane">
                                    In Progress
                                </div>
                                <div id="approved" class="tab-pane">
                                    Approved
                                </div>
                            </div>
                        </div>
                        <div id="action" class="tab-pane">
                            <ul className="nav nav-pills" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="pill" href="#pending">Pending 
                                        <label class="label-sm label-info m-l-5">0</label>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="pill" href="#approved_2">Approved
                                        <label class="label-sm label-danger m-l-5 text-white">0</label>
                                        <label class="label-sm label-success m-l-10 text-white">10</label>
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content mt-4">
                                <div id="pending" class="tab-pane active">
                                    Pending
                                </div>
                                <div id="approved_2" class="tab-pane">
                                    Approved
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Task;